import { Copy, Eye, X } from "react-feather";
import styles from "./tenantcontactinfo.module.css";
import { Dialog, DialogContent, Tooltip, Accordion, AccordionDetails, AccordionSummary, DialogTitle, DialogContentText, Button, DialogActions } from "@mui/material";
import { Link } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { useAuth0 } from "@auth0/auth0-react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CopyToClipboard from "react-copy-to-clipboard";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { communicationVoiceCallScreenOpen } from "../../../../../redux/actions/communicationVoiceCallScreenAction";
import { setVoiceCallInfo } from "../../../../../redux/actions/communicationVoiceCallInfo";

const TenantContactInfo = ({ tenantData, setLoading, activeTenant, expanded, handleChange }) => {
  const voiceCallInfo = useSelector((store) => store.communicationVoiceCallInfoReducer);
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();
  const [docUrl, setDocUrl] = useState("");
  const [openDocModal, setOpenDocModal] = useState(false);
  const [emailCopied, setEmailCopied] = useState(false);
  const [openCallModal, setOpenCallModal] = useState(false);
  const [prospectInfoObj, setProspectInfoObj] = useState(null);

  const viewDocumnet2 = async (id) => {
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    axios.get(process.env.REACT_APP_TENANT_API_URL + "v1/get-tenant-document/" + id, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);
      setOpenDocModal(true);
      setDocUrl(response.data.data?.file_url);
    }).catch((error) => {
      setLoading(false);
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
    });
  }

  const viewCreditReport = async (tenantInfoId) => {
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    axios.get(process.env.REACT_APP_TENANT_API_URL + "v1/get-report-link/" + tenantInfoId, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);
      window.open(response?.data?.url);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  const initiateVoiceCall = (item) => {
    if (voiceCallInfo) {
      toast.error("You are on anotehr call.");
    } else {
      setOpenCallModal(true);
      setProspectInfoObj(item);
    }
  };
  const initiateVoiceCallConfirm = () => {
    setOpenCallModal(false);
    let newProspectInfo = {
      id: prospectInfoObj?.tenant_id,
      full_name: prospectInfoObj?.full_name,
      initial: prospectInfoObj?.initial,
      phone: prospectInfoObj?.phone,
      user_avatar: prospectInfoObj?.user_image,
      type: "Tenant"
    };

    dispatch(communicationVoiceCallScreenOpen(true));
    dispatch(setVoiceCallInfo(newProspectInfo));
  };

  return (<Accordion expanded={expanded === "panel1"} onChange={handleChange("panel1")}>
    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
      <div className={`${styles.FormAccoHead}`}>
        <p className={`${styles.FormAccoHeadTitlePro}`}>Contact Info</p>
      </div>
    </AccordionSummary>
    <AccordionDetails>
      <div className={`${styles.SMProCardDe}`}>
        <ul>
          <li>
            <span className={`${styles.SMProDETag}`}>Email:</span>
            <CopyToClipboard text={tenantData?.all_tenants[activeTenant]?.email} onCopy={() => setEmailCopied(true)}>
              <Tooltip title={emailCopied ? "Copied" : "Copy"}>
                <a className={`${styles.SMProDE}`} style={{ cursor: "pointer" }}>
                  <Copy />
                  {tenantData?.all_tenants.length > 0 && tenantData?.all_tenants[activeTenant] && tenantData?.all_tenants[activeTenant]?.email}
                </a>
              </Tooltip>
            </CopyToClipboard>
          </li>
          <li>
            <span className={`${styles.SMProDETag}`}>Phone:</span>
            <Tooltip title="Start a voice call">
              <a className={`${styles.SMProDE}`} style={{ cursor: "pointer" }} onClick={(e) => { initiateVoiceCall(tenantData?.all_tenants[activeTenant]); }}>{tenantData?.all_tenants.length > 0 && tenantData?.all_tenants[activeTenant] && tenantData?.all_tenants[activeTenant]?.phone}</a>
            </Tooltip>
          </li>
          <li>
            <span className={`${styles.SMProDETag}`}>Property:</span>
            <Link to={"/properties/details/" + tenantData?.property_id} className={`${styles.SMProDE}`}>{tenantData?.property?.name}</Link>
          </li>
          <li>
            <span className={`${styles.SMProDETag}`}>Apartment:</span>
            <span className={`${styles.SMProDE}`}>{tenantData?.apartment?.apt_no}</span>
          </li>
          {/*<li>
            <span className={`${styles.SMProDETag}`}>Lease Term:</span>
            <Link to={"/leases/details/" + tenantData?.id} className={`${styles.SMProDE}`}>{moment(tenantData?.leases?.start_date).format("MM/DD/YYYY")}{" "}-{" "}{moment(tenantData?.leases?.end_date).format("MM/DD/YYYY")}</Link>
          </li>
          tenantData?.all_tenants[activeTenant]?.document_type !== "" && (<li>
            <span className={`${styles.SMProDETag}`}>Verification:</span>
            <Link className={`${styles.SMProDE}`} onClick={(e) => { e.preventDefault(); viewDocumnet2(tenantData?.all_tenants[activeTenant]?.id); }}>
              <Eye />
              {tenantData?.all_tenants[activeTenant]?.document_type === "passport" && "Passport"}
              {tenantData?.all_tenants[activeTenant]?.document_type === "id_card" && "Id Card"}
              {tenantData?.all_tenants[activeTenant]?.document_type === "driving_license" && "Driver License"}
            </Link>
          </li>)}
          {tenantData?.all_tenants[activeTenant]?.is_credit_score_verify === 1 && (<li>
            <span className={`${styles.SMProDETag}`}>Credit Score:</span>
            <Link className={`${styles.SMProDE}`} onClick={(e) => { e.preventDefault(); viewCreditReport(tenantData?.all_tenants[activeTenant]?.id); }}>
              <Eye />
              {tenantData?.all_tenants[activeTenant]?.credit_score}
            </Link>
            <img src="/static/img/verified.svg" className={`${styles.Varified}`} alt="" style={{ width: '16px', marginLeft: '12px' }} />
          </li>)*/}
        </ul>
      </div>

      <Dialog
        onClose={(e) => { setOpenDocModal(false); setDocUrl(""); }}
        aria-labelledby="customized-dialog-title"
        open={openDocModal}
        className="NewPopUp NewPopUpForLease"
      >
        <button onClick={(e) => { setOpenDocModal(false); setDocUrl(""); }} className={`${styles.IDImageCloseBU}`}><X /></button>
        <DialogContent>
          <div className={`${styles.IDImageSec}`}>
            <img src={docUrl} className={`${styles.IDImage}`} alt="" />
          </div>
        </DialogContent>
      </Dialog>

      <Dialog
        open={openCallModal}
        fullWidth
        maxWidth="sm"
        onClose={(e) => setOpenCallModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="NewPopUp"
      >
        <DialogTitle id="alert-dialog-title">
          Tenant Call Confirmation
          <button onClick={(e) => setOpenCallModal(false)}>
            <X />
          </button>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div className="ModalFormGroup">
              <label className="PopupBodyText">Please confirm you wish to initiate a call to this tenant.</label>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => setOpenCallModal(false)} className="CancelPopupBU">Cancel</Button>
          <Button onClick={(e) => initiateVoiceCallConfirm()} className="SubmitPopupBU">Proceed</Button>
        </DialogActions>
      </Dialog>

    </AccordionDetails>
  </Accordion>);
};

export default TenantContactInfo;